import { Flex, Spinner } from "@chakra-ui/react";
import React from "react";
import { COLORS } from "../../Helper/Colors";

const PageLoader = ({ isLoading, spinnerColor, children }) => {
	return (
		<>
			{isLoading ? (
				<Flex height={"100%"} width={"100%"} alignItems='center' justifyContent={"center"}>
					<Spinner thickness='5px' speed='1s' emptyColor='gray.200' color={spinnerColor || COLORS.brand} size='xl' />
				</Flex>
			) : (
				children
			)}
		</>
	);
};

export default PageLoader;
